<template>
	<div v-show="isShow" class="chat-system-content">
		<el-container>
			<el-header height="50px" :class="configStore.electronMode ? 'header-menu-wrap' : ''">
				<span class="back el-icon-back" @click="onBack()"></span>
			</el-header>
			<el-main>
				<span class="title">{{ title }}</span>
				<div v-if="contentType == 0" class="rich-text" v-html="richText"></div>
				<div v-else-if="isInnerLink" class="inner-link-card" @click="onOpenInnerLink">
					<div class="inner-link-title">{{ title }}</div>
					<div class="inner-link-tip">{{ $t('chat.viewDetail') }}</div>
				</div>
				<iframe v-else class="ext-link" :src="externLink"></iframe>
			</el-main>
		</el-container>
	</div>
</template>

<script>
import { Base64 } from 'js-base64';

export default {
	name: "chatSystemContent",
	data() {
		return {
			isShow: false,
			title: "",
			contentType: 0,
			richText: "",
			externLink: ""
		}
	},
	methods: {
		show(id, title) {
			this.$http({
				url: '/message/system/content?id=' + id,
				method: 'get',
			}).then(message => {
				this.title = title;
				this.richText = Base64.decode(message.richText);
				this.externLink = message.externLink;
				this.contentType = message.contentType;
				this.isShow = true;
			})
		},
		onOpenInnerLink() {
			const suggestionPrefix = '/pages/suggestion/suggestion-info?id=';
			if (this.externLink.startsWith(suggestionPrefix)) {
				const id = this.externLink.substring(suggestionPrefix.length);
				this.$router.push(`/home/setting?component=suggestion&id=${id}`);
			}
		},
		onBack() {
			this.isShow = false;
		}
	},
	computed: {
		isInnerLink() {
			return this.externLink && this.externLink.startsWith('/pages/');
		}
	}
}
</script>

<style lang="scss">
.chat-system-content {
	position: absolute;
	background-color: white;
	width: 100%;
	height: 100%;

	.title {
		font-size: 24px;
		font-weight: bolder;
		text-align: center;
		display: block;
		margin-top: 10px;
	}

	.back {
		position: absolute;
		left: 20px;
		line-height: 50px;
		font-size: 26px;
		cursor: pointer;
	}

	.rich-text {
		padding: 10px 20px 20px 20px;
	}

	.inner-link-card {
		width: 420px;
		margin: 40px auto;
		background: #f8f8f8;
		border-radius: 10px;
		padding: 24px;
		cursor: pointer;

		.inner-link-title {
			font-size: 18px;
			font-weight: 600;
			margin-bottom: 12px;
		}

		.inner-link-tip {
			color: var(--im-color-primary);
		}
	}

	.ext-link {
		width: 100%;
		height: 100%;
		border: none;
	}
}
</style>